import {
  ModelVersionENV,
  ModelVersionENVValues,
  ModelVersionESS,
  ModelVersionESSValues,
} from '@/domain/project/entities/project.entity';
import {
  ProjectFestival,
  Venue,
  VenueValues,
} from '@/domain/project-festival/entities/project-festival.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { ProjectDto } from './project-festival.dto.schema';

type ProjectDtoOmitId = Omit<ProjectDto, 'id' | 'models'>;

export class ProjectMapper {
  static dtoToEntity(dto: ProjectDto): ProjectFestival {
    return {
      id: dto.id,
      organisationId: dto.organisationId,
      type: 'festival',
      name: dto.name,
      image: dto.image || '',
      startDate: dto.startDate,
      endDate: dto.endDate,
      location: dto.location,
      venue: validateValueInType<Venue>(dto.venue, VenueValues),
      avgCapacity: dto.properties?.avgCapacity || 0,
      accessToEnergy: dto.properties?.accessToEnergy || false,
      accessToWater: dto.properties?.accessToWater || false,
      calculateOptions: {
        includePublicAnswersForCo2:
          dto.properties?.calculateOptions?.includePublicAnswersForCo2 ?? true,
      },
      models: {
        env: validateValueInType<ModelVersionENV>(
          dto.models.env,
          ModelVersionENVValues,
        ),
        ess: validateValueInType<ModelVersionESS>(
          dto.models.ess,
          ModelVersionESSValues,
        ),
      },
    };
  }

  static entityToDto(project: ProjectFestival): ProjectDtoOmitId {
    return {
      // id: project.id || 0, // no id
      organisationId: project.organisationId || 0,
      image: project.image,
      name: project.name,
      location: project.location,
      startDate: project.startDate
        ? new Date(project.startDate).toISOString()
        : null,
      endDate: project.endDate ? new Date(project.endDate).toISOString() : null,
      venue: project.venue,
      properties: {
        avgCapacity: project.avgCapacity,
        accessToEnergy: project.accessToEnergy,
        accessToWater: project.accessToWater,
        calculateOptions: project.calculateOptions,
      },
    };
  }
}
